import styled from '@emotion/styled';
import { Breadcrumb } from 'antd';

import theme from '../theme';

export const InternalContainer = styled.div`
  max-width: ${theme.screenLgMax};
  margin: auto;
  padding-bottom: 48px;

  @media (max-width: ${theme.screenLgMax}) {
    padding-left: 24px;
    padding-right: 24px;
  }

  @media (max-width: ${theme.screenMdMax}) {
    padding-left: 12px;
    padding-right: 12px;
  }

  @media (max-width: ${theme.screenXsMax}) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const CustomInternalContainer = styled.div`
  max-width: ${theme.screenLgMax};
  margin: auto;
  padding-bottom: 48px;
  padding-top: 20px;

  @media (max-width: ${theme.screenLgMax}) {
    padding: 0;
  }
`;

export const CustomInternalContainerSm = styled.div`
  max-width: ${theme.screenLgMax};
  margin: auto;
  padding-top: 20px;
  @media (max-width: ${theme.screenLgMax}) {
    padding: 0;
  }
`;

const HeaderBase = `
color: ${theme.colorsBlack};
letter-spacing: -0.4px;
line-height: 38px;
font-weight: bold;
`;

const TextBase = `
color: ${theme.colorsBlack};
font-size: 18px;
`;

export const Header = styled.h2`
  ${HeaderBase}
  font-size: 32px;
  padding: 40px 0;
`;

export const StyledH6 = styled.h6`
  ${HeaderBase}
  font-size: 22px;
`;

export const ArticleWrapper = styled.div`
  padding-bottom: 32px;
  margin-bottom: 40px;
  border-bottom: 1px solid ${theme.colorsHr};
`;

export const Label = styled.div`
  ${HeaderBase}
  font-size: 22px;
  letter-spacing: -0.4px;
  padding-bottom: 8px;
`;

export const StyledP = styled.p`
  ${TextBase}
  letter-spacing: 0;
  line-height: 28px;
`;

export const StyledDiv = styled.div`
  ${TextBase}
  letter-spacing: 0;
  line-height: 28px;
`;

export const Date = styled.p`
  ${TextBase}
  letter-spacing: 0;
  line-height: 28px;
  opacity: 0.5;
  padding-bottom: 16px;
`;

export const Summary = styled.div<{ hasImage: boolean }>`
  ${TextBase}
  letter-spacing: 0;
  line-height: 28px;
  padding-left: ${(props) => (props.hasImage ? '32px' : '0')};

  @media (max-width: ${theme.screenLgMax}) {
    padding-left: 0;
  }
`;

export const PageContent = styled.div`
  h1 {
    ${HeaderBase}
    font-size: 40px;
  }
  h2 {
    ${HeaderBase}
    font-size: 32px;
  }
  h3 {
    ${HeaderBase}
    font-size: 24px;
  }
  h4 {
    ${HeaderBase}
    font-size: 22px;
    line-height: 29px;
    padding-bottom: 16px;

    &:nth-of-type(n + 2) {
      padding-top: 16px;
    }
  }

  h5 {
    ${HeaderBase}
    font-size: 18px;
  }

  p {
    ${TextBase}
    letter-spacing: 0;
    line-height: 28px;
    padding-bottom: 16px;

    .video-wrapper {
      overflow: hidden;
      display: block;
      text-align: center;
      padding: 24px 0;
      @media (max-width: ${theme.screenMdMax}) {
        width: 90vw;
        height: 40vh;
        iframe {
          width: 100% !important;
          height: 100% !important;
        }
      }
    }
  }

  a {
    ${TextBase}
    color: ${theme.colorsSecondaryBlue};

    &:hover {
      text-decoration: underline;
      font-weight: bold;
    }

    &:visited {
      color: ${theme.colorsVisitedLinks};
    }
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
  }

  ul {
    list-style: disc inside none;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  border-radius: 5px;
`;

export const StyledBreadcrumb = styled(Breadcrumb)`
  & > span {
    color: ${theme.colorsBlack};
  }
  & > span:first-of-type a {
    text-decoration: underline;
  }

  & > span {
    color: ${theme.colorsBlack};
  }

  .ant-breadcrumb-link,
  a {
    color: ${theme.colorsBlack};
  }
  .ant-breadcrumb-separator {
    color: ${theme.colorsBlack};
    font-weight: bold;
  }
`;

export const BasicContainer = styled(CustomInternalContainerSm)``;

export const SectionWrapper = styled.div`
  margin: 35px 0 40px 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: ${theme.screenMd}) {
    margin-top: 10px;
    padding: 0 24px;
  }
`;

export const SectionTitle = styled.h3`
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 15px;
  @media (max-width: ${theme.screenMd}) {
    margin-top: 25px;
  }
`;

export const SectionBody = styled.div`
  font-size: 18px;
`;

export const SectionTitleSm = styled.h3`
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 5px;
  @media (max-width: ${theme.screenMd}) {
    margin-top: 5px;
  }
`;

export const PositionWrapper = styled.div`
  margin: 35px 0 40px 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 15px;
  @media (max-width: ${theme.screenMd}) {
    margin-top: 10px;
    padding: 0 24px 10px 24px;
  }
`;
